import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

interface LibrarianExportDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onExport: () => Promise<void>;
  loading?: boolean;
  pageCount: number;
}

export default function LibrarianExportDialog({ open, onOpenChange, onExport, loading = false, pageCount }: LibrarianExportDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="overflow-hidden border-border/70 bg-background/95 p-0 shadow-2xl sm:max-w-[560px]">
        <DialogHeader className="border-b border-border/60 px-6 py-5">
          <DialogTitle>Export Librarian vault</DialogTitle>
          <DialogDescription>
            Download the current vault as a markdown bundle that preserves the filesystem-style page paths.
          </DialogDescription>
        </DialogHeader>

        <div className="px-6 py-5">
          <div className="rounded-xl border border-border/70 bg-muted/20 p-4 text-sm text-muted-foreground">
            This export includes {pageCount} page{pageCount === 1 ? '' : 's'} in one markdown bundle, with each page separated by its vault path.
          </div>
        </div>

        <DialogFooter className="border-t border-border/60 px-6 py-4">
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button onClick={onExport} disabled={loading}>
            {loading ? 'Exporting…' : 'Download bundle'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}